export class SavedLocation {
    public displayName: string;
    public lat: number;
    public lon: number;

    constructor(givenName: string, givenLat: number, givenLon: number) {
        this.displayName = givenName;
        this.lat = givenLat;
        this.lon = givenLon;
    }
}


// WEBPACK FOOTER //
// ./src/classes/SavedLocation.ts